import normalizeComponent from "../../../_virtual/_plugin-vue2_normalizer.mjs";
const _sfc_main = {};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("svg", { attrs: { "width": "20", "height": "20", "viewBox": "0 0 20 20", "fill": "none", "xmlns": "http://www.w3.org/2000/svg" } }, [_c("g", { attrs: { "id": "Union" } }, [_c("path", { attrs: { "d": "M5.58366 10.0765L9.18 13.7056L14.6337 7.55301L13.5737 6.66671L8.97813 10.9392L6.42526 9.16785L5.58366 10.0765Z", "fill": "#00B89C" } }), _c("path", { attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M19.1668 10C19.1668 15.0626 15.0628 19.1667 10.0002 19.1667C4.93755 19.1667 0.833496 15.0626 0.833496 10C0.833496 4.93743 4.93755 0.833374 10.0002 0.833374C15.0628 0.833374 19.1668 4.93743 19.1668 10ZM17.5002 10C17.5002 14.1422 14.1423 17.5 10.0002 17.5C5.85803 17.5 2.50016 14.1422 2.50016 10C2.50016 5.8579 5.85803 2.50004 10.0002 2.50004C14.1423 2.50004 17.5002 5.8579 17.5002 10Z", "fill": "#00B89C" } })])]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null
);
const SuccessIcon = __component__.exports;
export {
  SuccessIcon as default
};
